<stages-dialog2 #dialog>
	<stages-dialog-header>
		@if (credentialsValid) {
			@if (fileAccessType !== "LINK") {
				<header class="title">
					<i class="ico ico-export"></i>
					<h2 translate="files.download"></h2>
				</header>
			} @else {
				<header class="title">
					<h2 translate="open"></h2>
				</header>
			}
		}
	</stages-dialog-header>

	@if (credentialsValid) {
		<div class="content">
			<div class="panel">
				@if (fileAccessType !== "LINK") {
					<p translate="files.downloadAutomatically"></p>
					<p>
						@if (downloadUrl) {
							<iframe style="display: none" [src]="downloadUrl | safe: 'resourceUrl'" (load)="iframeLoaded($event)">
							</iframe>
						}
						<a [href]="downloadUrl" class="clickable" translate="files.downloadManually"> </a>
					</p>
					@if (errorMessage) {
						<div class="error" role="alert">{{ errorMessage }}</div>
					}
				} @else {
					<p>
						<a [href]="downloadUrl" target="_blank" class="clickable"
							><i class="ico ico-inline ico-navigate-to"></i> {{ filename }}</a
						>
					</p>
					@if (errorMessage) {
						<div class="error" role="alert">{{ errorMessage }}</div>
					}
				}
			</div>
		</div>
		<footer>
			<div class="buttons">
				<button (click)="dialog.close()" class="button lg prime" translate="close"></button>
			</div>
		</footer>
	}

	@if (!credentialsValid && !oAuthUrl) {
		<stages-files-auth-embeddable #auth [cmsTypeMessageKey]="cmsTypeMessageKey!" [keys]="$any(keys)" />
	}
	@if (!credentialsValid && oAuthUrl) {
		<stages-files-oauth-embeddable-confirm
			[cmsTypeMessageKey]="cmsTypeMessageKey!"
			[authUrl]="oAuthUrl"
			[closeCallback]="dialog.close"
		/>
	}
</stages-dialog2>
